<!--
 * @Descripttion:
 * @Author: zcy
 * @Date: 2022-01-07 10:16:16
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-15 15:03:22
-->
<template>
  <div class="page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>日期&nbsp;:</label>
          <el-date-picker value-format="yyyy-MM" v-model="param.params.costMonth" type="month" placeholder="请选择月份">
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="param.params.baseId" filterable @change="getGroupList(param.params.baseId)"
            placeholder="请选择养殖场">
            <el-option label="全部养殖场" value=""></el-option>
            <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>区域&nbsp;:</label>
          <el-select v-model="param.params.groupId" filterable placeholder="请选择区域">
            <el-option label="全部区域" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>育苗批次&nbsp;:</label>
          <el-select v-model="param.params.seedlingDataId" filterable placeholder="请选择育苗批次">
            <el-option label="全部育苗批次" value=""></el-option>
            <el-option :key="item.id" v-for="item in PiCiList" :label="item.seedlingDataName"
              :value="item.seedlingDataId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="param.params.breedTypeId" filterable placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinLeiList" :label="item.breedTypeName"
              :value="item.breedTypeId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" filterable placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinZhongList" :label="item.breedName"
              :value="item.breedId"></el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reSet">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>育苗月存塘成本统计表</div>
        <div>单位 : {{ tableTitle }}</div>
        <div>日期 : {{ tableDate }}</div>
        <div style="cursor: unset">
          <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="monthDetailedPage" style="cursor: pointer; color: #1800f9; margin-right: 20px">明细</span>
          <span @click="doExport" style="cursor: pointer"><i
              class="title-export-btn iconfont icon-a-List-Export"></i>导出报表</span>
        </div>
      </div>
      <el-table :row-class-name="tableRowClassName" :data="tableData" :max-height="tableHeight" border style="width: 100%"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="seedlingDataName" label="育苗批次">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedName" label="育苗品种"></el-table-column>
        <el-table-column label="变动成本">
          <el-table-column label="卵成本">
            <el-table-column prop="putNumberSeed" label="数量(k/g)"></el-table-column>
            <el-table-column prop="putMoneySeed" label="金额"></el-table-column>
          </el-table-column>
          <el-table-column label="饲料">
            <el-table-column prop="putNumberFodd" :label="'数量(' + fodderKgToJin + ')'"></el-table-column>
            <el-table-column prop="putMoneyFodd" label="金额"></el-table-column>
          </el-table-column>
          <el-table-column prop="putMoneyDrug" label="动保"></el-table-column>
          <el-table-column prop="costElectricCost" label="电费"></el-table-column>
          <el-table-column prop="costArtificialCost" label="人工"></el-table-column>
          <el-table-column prop="costConsumableCost" label="低值易耗品"></el-table-column>
          <el-table-column prop="costNetCost" label="拉网费"></el-table-column>
          <el-table-column prop="costDeprecitCost" label="折旧与摊销"></el-table-column>
          <el-table-column prop="repairCost" label="修理费"></el-table-column>
          <el-table-column prop="fuelFee" label="燃料费"></el-table-column>
          <el-table-column prop="rentalFee" label="租凭费"></el-table-column>
          <el-table-column prop="costPublic" label="其他公摊"></el-table-column>
        </el-table-column>
        <el-table-column label="定额费用">
          <el-table-column prop="costOldCost" label="网箱折旧"></el-table-column>
          <el-table-column prop="costManageCost" label="网箱管理费"></el-table-column>
          <el-table-column prop="costSeaAreaCost" label="海域费"></el-table-column>
          <el-table-column prop="costRentPondCost" label="塘租"></el-table-column>
        </el-table-column>
        <el-table-column prop="costTotal" label="成本合计"></el-table-column>
        <el-table-column label="存塘信息">
          <el-table-column prop="seedlingDays" label="育苗天数"></el-table-column>
          <el-table-column prop="avgSpec" label="存塘规格"></el-table-column>
          <el-table-column prop="storageFishNum" label="存塘数量"></el-table-column>
          <el-table-column prop="storageWeight" label="存塘重量"></el-table-column>
          <el-table-column prop="unitCostTotal" label="单位成本"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Page from "@/utils/methods/page";
import {
  monthInitPageList,
  getAllJiGouMonth,
  getAllPiCiMonth,
  getAllPinLeiMonth,
  getAllPinZhongMonth,
} from "./ym-overage-services";
import {
  queryBaseDataListByRole,
  queryBaseGroupList,
} from "@/api/middle/common";
import { listParamStatus } from "@/api/general.js";
export default {
  data() {
    return {
      tableTitle: "",
      tableDate: "",
      value: "",
      PageDisplay: true,
      tableData: [],
      baseList: [], //养殖场下拉数据
      groupList: [], //区域下拉数据
      GongSiList: [],
      PiCiList: [],
      PinLeiList: [],
      PinZhongList: [],
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "seedlingDataName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "org_name",
        params: {
          baseId: "",
          groupId: "",
          orgId: localStorage.getItem("orgId"),
          seedlingDataId: "",
          periodId: "",
          breedTypeId: "",
          breedId: "",
          costMonth: Page.getCurrentMonth(),
          breedTypeClass: "egg",
        },
      },
      fodderKgToJin: "公斤", // 是否把公斤转换成斤
    };
  },
  watch: {
    dateSelectNum: function (newValue, oldValue) {
      console.log(newValue);
    },
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
  },
  mounted() {
    this.initPage(this.param);
    Page.pagesTableFixed();
    this.getAllSearchSelect();
    // 养殖场
    queryBaseDataListByRole().then((res) => {
      if (res.code == "0000") {
        this.baseList = res.data;
      }
    });
    // 获取是否公斤转换成斤
    listParamStatus(this.param.params.orgId, ["fodderKgToJin"]).then((res) => {
      if (res.code == "0000") {
        this.fodderKgToJin = res.data.fodderKgToJin === true ? "斤" : "公斤";
      }
    });
  },
  methods: {
    // 根据养殖场获取区域
    getGroupList(baseId) {
      this.param.params.groupId = "";
      this.groupList = [];
      if (!baseId) return;
      this.param.params.groupId = "";
      queryBaseGroupList({
        baseId,
      }).then((res) => {
        if (res.code == "0000") {
          this.groupList = res.data;
        }
      });
    },
    // 跳转月存塘成本明细报表
    monthDetailedPage() {
      let routeUrl = this.$router.resolve({
        path: "/month/ym/overage-condition",
        // query: { id: 96 },
      });
      window.open(routeUrl.href, "_blank");
    },
    search() {
      this.initPage(this.param);
    },
    reSet() {
      this.groupList = [];
      this.param = {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "org_name",
        params: {
          baseId: "",
          groupId: "",
          orgId: localStorage.getItem("orgId"),
          seedlingDataId: "",
          periodId: "",
          breedTypeId: "",
          breedId: "",
          costMonth: Page.getCurrentMonth(),
          breedTypeClass: "egg",
        },
      };
      this.initPage(this.param);
    },
    // 获取所有下拉选择项
    getAllSearchSelect() {
      let param = {
        breedTypeClass: "egg",
        orgId: localStorage.getItem("orgId"),
      };
      Promise.all([
        getAllJiGouMonth(param),
        getAllPiCiMonth(param),
        getAllPinLeiMonth(param),
        getAllPinZhongMonth(param),
      ])
        .then((result) => {
          const [JiGouData, PiCiData, PinLeiData, PinZhongData] = result;
          this.GongSiList = JiGouData.data;
          this.PiCiList = PiCiData.data;
          this.PinLeiList = PinLeiData.data;
          this.PinZhongList = PinZhongData.data;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 育苗-存塘概览报表-实时存塘量
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            title: "育苗/养成月存塘成本统计表",
            groupId: this.param.params.rootOrgId,
            orgId: this.param.params.orgId,
            seedlingDataId: this.param.params.seedlingDataId,
            periodId: this.param.params.periodId,
            breedTypeId: this.param.params.breedTypeId,
            breedId: this.param.params.breedId,
            costMonth: this.param.params.costMonth,
            breedTypeClass: "egg",
            fileName: "育苗-存塘概览报表-月存塘成本",
          };
          const flag = await Page.exportDatas(
            "/midCostTotalGroup/exportMdtPondHarvestList",
            param
          );
        })
        .catch(() => { });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.groupName === "合计") {
        return "heji-row";
      }
    },
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      monthInitPageList(data)
        .then((res) => {
          this.tableTitle = localStorage.getItem("orgName");
          this.tableDate = Page.costMonthFilter(data.params.costMonth);
          this.tableData = res.data.list;
          setTimeout(() => {
            loading.close();
          }, 0);
        })
        .catch((err) => this.$message.error(err));
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped></style>



